import { render, staticRenderFns } from "./BanExpiration.vue?vue&type=template&id=47e56cd2&"
import script from "./BanExpiration.vue?vue&type=script&lang=js&"
export * from "./BanExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports